import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  Company,
  Contact,
  Contractor,
  InspectionDto,
  InspectionModel,
  Order,
  Planner,
  Project,
  SubProject,
  User
} from '@authority-labs/api-interfaces';
import { InspectionTypeEnum } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateComponent implements OnInit {
  @Input() apiUrl: string;
  @Input() order: Order;
  @Input() planner: Planner;
  @Input() contractor: Contractor;
  @Input() project: Project;
  @Input() subProject: SubProject;
  @Input() company: Company;
  @Input() contact: Contact;
  @Input() inspection: InspectionDto;
  @Input() assignee: User;
  @Input() approval: User;

  orderId: string;

  get isInspectionInstallation(): boolean {
    return [
      InspectionTypeEnum.InspectionInstallation,
      InspectionTypeEnum.InspectionDesignAndInstallation
    ].includes(this.inspection?.inspectionType);
  }

  ngOnInit(): void {
    this.inspection = new InspectionModel(this.inspection);
  }
}
